import { useState } from "react";
import axios from "axios";
import Modal from "react-modal";
import { useMsal } from "@azure/msal-react";
import "./Floaticons.css";

import "./Feedback.css";

const modalStyling = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  content: {
    left: "38%",
    top: "20%",
    bottom: "42%",
    padding: "30px",
    position: "absolute",
    inset: "13% 40px 42% 38%",
    border: "1px solid rgb(204, 204, 204)",
    background: "rgb(255, 255, 255)",
    overflow: "auto",
    borderRadius: "4px",
    outline: "none",
    padding: "30px",
    width: "32%",
  },
};

export default function Feedback() {
  const [open, setOpen] = useState(false);
  const [feedbackRes, setFeedbackRes] = useState("");
  const [toggle, setToggle] = useState(true);
  const [comment, setComment] = useState("");
  const [taInlnStyle, setTaInlnStyle] = useState({ height: "15px" });
  const [rating, setRating] = useState([]);

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const handleOpen = () => {
    setOpen(true);
    setToggle(true);
    setRating([]);
  };

  const handleClose = () => {
    setOpen(false);
    setToggle(false);
  };

  const handleComment = (commentVal) => {
    if (commentVal.length > 46 && commentVal.length < 92) {
      setTaInlnStyle({ height: "45px" });
    } else if (commentVal.length > 92) {
      setTaInlnStyle({ height: "70px" });
    } else if (commentVal.length < 46) {
      setTaInlnStyle({ height: "21px" });
    }
    setComment(commentVal);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    //   if(process.env.NODE_ENV === 'development') {
    //       alert("Not allowed to submit feedback from localhost.");
    //   }
    //   else
    //   {
    setToggle(false);
    axios
      .post(
        "https://atci.lkm.foreignlanguage.accenture.com/foreign-apis/feedback",
        {
          enterprise_id: activeAccount.idTokenClaims.enterpriseID,
          rating: rating.length,
          comment: comment,
        },
        {
          headers: {              
            'Authorization': localStorage.getItem("token"),
            'Content-Type': 'application/json'
          }
        })
      .then((response) => {
        setFeedbackRes(response.data.message);
      })
      .catch((error) => {
        setFeedbackRes(error.data.message);
      });
    setComment("");
    //   }
  };

  const body = (
    <div>
      {toggle && (
        <div id="feedback_form">
          <form onSubmit={handleSubmit}>
            <div className="feedback_label">Send Feedback</div>
            <div className="feedback">
              <span id="thankYou-close" onClick={handleClose}></span>
              <h6 className="question">
                Tell us your experience with the European Language Portal!
              </h6>
              <div className="feedback-rating">
                <img
                  src={
                    rating.includes(1)
                      ? "images/feedback/star_active.svg"
                      : "images/feedback/star_inactive.svg"
                  }
                  alt=""
                  onClick={() => setRating([1])}
                />
                <img
                  src={
                    rating.includes(2)
                      ? "images/feedback/star_active.svg"
                      : "images/feedback/star_inactive.svg"
                  }
                  alt=""
                  onClick={() => setRating([1, 2])}
                />
                <img
                  src={
                    rating.includes(3)
                      ? "images/feedback/star_active.svg"
                      : "images/feedback/star_inactive.svg"
                  }
                  alt=""
                  onClick={() => setRating([1, 2, 3])}
                />
                <img
                  src={
                    rating.includes(4)
                      ? "images/feedback/star_active.svg"
                      : "images/feedback/star_inactive.svg"
                  }
                  alt=""
                  onClick={() => setRating([1, 2, 3, 4])}
                />
                <img
                  src={
                    rating.includes(5)
                      ? "images/feedback/star_active.svg"
                      : "images/feedback/star_inactive.svg"
                  }
                  alt=""
                  onClick={() => setRating([1, 2, 3, 4, 5])}
                />
                <p id="star-text" tabindex="0">
                  {rating.length}/5
                </p>
              </div>
              <textarea
                onChange={(event) => {
                  handleComment(event.target.value);
                }}
                id="feedback-input"
                type="text"
                rows="2"
                placeholder="Please provide suggestions or feedback here"
                style={taInlnStyle}
              ></textarea>
              <div className="submit">
                <button type="submit">Send</button>
              </div>
            </div>
          </form>
        </div>
      )}
      {!toggle && (
        <div id="success_form">
          <span id="thankYou-close" onClick={handleClose}></span>
          <h2 className="feedback-success">Thank you!</h2>
          <p className="feedback-success-msg">{feedbackRes}</p>
        </div>
      )}
    </div>
  );

  return (
    <>
      {/* <div className="float-box box3"> */}
      <a href="#" className="floatIconA">
        <img
          src={process.env.PUBLIC_URL + "/images/FloatIcons/Feedback.png"}
          className="FloatIconMailIcon"
          alt="icons"
        />

        <p onClick={handleOpen} className="FloatIconName">
          Feedback
        </p>
      </a>
      {/* </div> */}
      <Modal isOpen={open} className="modal-feedback">
        {body}
      </Modal>

      {/* <a href="" className="floatIconA">
        <img
          src="/images/homePage/feedback.png"
          alt="Mail-Icon"
          className="FloatIconMailIcon"
        />
        <p className="FloatIconName">Feedback</p>
      </a> */}
    </>
  );
}
